import {
    AddAttachmentToClaimInput,
    GetClaimUploadTemplatesOutput,
    GenerateClaimTemplateInput,
    GenerateClaimTemplateOutput,
    GetClaimByResellerClaimNumberInput,
    GetClaimByResellerClaimNumberOutput,
    RequestClaimDocumentUrlInput,
    RequestClaimDocumentUrlOutput,
    ProcessClaimUploadInput,
    ProcessClaimUploadOutput,
    RemoveAttachmentFromClaimInput,
    RequestClaimUploadUrlInput,
    RequestClaimUploadUrlOutput,
    ProcessPdfClaimUploadInput,
    ProcessPdfClaimUploadOutput,
} from '../types';
import { Logger } from '../utils/logger';
import { HrpsApiClient } from './HrpsApiClient';

export const getClaimDocumentUrl = async (
    requestClaimDocumentUrlInput: RequestClaimDocumentUrlInput
): Promise<RequestClaimDocumentUrlOutput> => {
    Logger.info('Requesting Document', requestClaimDocumentUrlInput);
    return await new HrpsApiClient()
        .callHrps('getClaimDocumentUrl', requestClaimDocumentUrlInput)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            Logger.debug('Error getting claim document: ', error.message);
            throw error;
        });
};

export const requestClaimUploadUrl = async (
    requestClaimUploadUrlInput: RequestClaimUploadUrlInput
): Promise<RequestClaimUploadUrlOutput> => {
    Logger.info('Requesting Upload Url', requestClaimUploadUrlInput);
    return await new HrpsApiClient()
        .callHrps('requestClaimUploadUrl', requestClaimUploadUrlInput)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            Logger.debug('Error getting claim upload URL: ', error.message);
            throw error;
        });
};

export const processClaimUpload = async (
    processClaimUploadInput: ProcessClaimUploadInput
): Promise<ProcessClaimUploadOutput> => {
    Logger.info('Processing File', processClaimUploadInput);
    return await new HrpsApiClient()
        .callHrps('processClaimUpload', processClaimUploadInput)
        .then((response) => {
            Logger.debug(response.data);
            return response.data;
        })
        .catch((error) => {
            Logger.debug('Error processing claim upload: ', error.message);
            throw error;
        });
};

export const processPdfClaimUpload = async (
    processPdfClaimUploadInput: ProcessPdfClaimUploadInput
): Promise<ProcessPdfClaimUploadOutput> => {
    Logger.info('Processing PDF claim file upload', processPdfClaimUploadInput);
    return await new HrpsApiClient()
        .callHrps('processPdfClaimUpload', processPdfClaimUploadInput)
        .then((response) => {
            Logger.debug(response.data);
            return response.data;
        })
        .catch((error) => {
            Logger.debug('Error processing PDF claim upload: ', error.message);
            throw error;
        });
};

export const generateClaimTemplate = async (
    generateClaimTemplateInput: GenerateClaimTemplateInput
): Promise<GenerateClaimTemplateOutput> => {
    Logger.info('Generating claim template ', generateClaimTemplateInput);
    return await new HrpsApiClient()
        .callHrps('generateClaimTemplate', generateClaimTemplateInput)
        .then((response) => {
            Logger.debug(response.data);
            return response.data;
        })
        .catch((error) => {
            Logger.debug('Error generating claim upload: ', error.message);
            throw error;
        });
};

export const getClaimUploadTemplates = async (): Promise<GetClaimUploadTemplatesOutput> => {
    Logger.info('Calling getClaimUploadTemplates');
    return await new HrpsApiClient()
        .callHrps('getClaimUploadTemplates', {})
        .then((response) => {
            Logger.debug(response.data);
            return {
                templates: response.data.ClaimUploadTemplates.map((rouTemplate: any) => {
                    return {
                        id: rouTemplate.id,
                        type: rouTemplate.type,
                        name: rouTemplate.title,
                        description: rouTemplate.description,
                        uploadedAt: new Date(rouTemplate.uploadedAt * 1000),
                        uploadedBy: rouTemplate.uploadedBy,
                        presignedURL: rouTemplate.url,
                        countryCode: rouTemplate.countryCode,
                    };
                }),
            } as GetClaimUploadTemplatesOutput;
        })
        .catch((error) => {
            Logger.debug('Error getting claim Upload Template: ', error.message);
            throw error;
        });
};

export const getClaimByResellerClaimNumber = async (
    input: GetClaimByResellerClaimNumberInput
): Promise<GetClaimByResellerClaimNumberOutput> => {
    Logger.info('Getting claim by reseller claim number', input);
    return await new HrpsApiClient()
        .callHrps('getClaimByResellerClaimNumber', input)
        .then((response) => {
            return response.data;
        })
        .catch((error) => {
            Logger.debug('Error getting claim by reseller claim number: ', error.message);
            throw error;
        });
};

export const addAttachmentToClaim = async (input: AddAttachmentToClaimInput): Promise<void> => {
    Logger.info('Adding attachment to claim', input);
    await new HrpsApiClient().callHrps('addAttachmentToClaim', input).catch((error) => {
        Logger.debug('Error adding attachment to claim: ', error.message);
        throw error;
    });
};

export const removeAttachmentFromClaim = async (input: RemoveAttachmentFromClaimInput): Promise<void> => {
    Logger.info('Removing attachment from claim', input);
    await new HrpsApiClient().callHrps('removeAttachmentFromClaim', input).catch((error) => {
        Logger.debug('Error removing attachment from claim: ', error.message);
        throw error;
    });
};
